import React from 'react';

import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  InputGroup,
  InputRightElement,
  Textarea as ChakraTextarea,
  TextareaProps as ChakraTextareaProps,
} from '@chakra-ui/react';

import { getInputIcon } from './getInputIcon';
import { getInputVariant } from './getInputVariant';
import { getMessageColorForStatus, InputStatus } from './InputStatus';
import { BoxProps } from '../../reexport';

interface TextareaProps
  extends Omit<BoxProps, 'onChange' | 'onFocus' | 'onBlur'> {
  name?: string;
  id?: string;
  label?: string;
  placeholder?: string;
  value?: string;
  reset?: () => void;
  onChange?: (value: string) => void;
  onBlur?: React.FocusEventHandler<HTMLTextAreaElement>;
  onFocus?: React.FocusEventHandler<HTMLTextAreaElement>;
  inputStatus?: InputStatus;
  message?: string;
  resize?: ChakraTextareaProps['resize'];
}

export function Textarea({
  name,
  id,
  label,
  placeholder,
  value,
  onChange,
  message,
  inputStatus,
  onFocus,
  onBlur,
  reset,
  resize,
  ...props
}: TextareaProps) {
  const rightIcon = getInputIcon(inputStatus);

  return (
    <FormControl
      w='100%'
      h='100%'
      display='flex'
      flexDir='column'
      rowGap='6px'
      {...props}
    >
      <FormLabel
        color='grey.tertiaryText'
        fontSize='sm'
        fontWeight='medium'
        lineHeight='20px'
        m='0 0 0 2px'
        htmlFor={id}
      >
        {label}
      </FormLabel>
      <InputGroup variant={getInputVariant(inputStatus)}>
        <ChakraTextarea
          id={id}
          name={name}
          placeholder={placeholder}
          color='grey.primaryText'
          backgroundColor='grey.white'
          disabled={inputStatus === 'DISABLED'}
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          onFocus={onFocus}
          onBlur={onBlur}
          resize={resize}
        />

        {rightIcon ? (
          <InputRightElement bottom='0px' top='inherit'>
            {rightIcon}
          </InputRightElement>
        ) : null}
      </InputGroup>

      <FormErrorMessage
        fontSize='sm'
        color={getMessageColorForStatus(inputStatus)}
        fontWeight='400'
        position='absolute'
        left='2px'
        bottom='-4px'
        transform='translateY(100%)'
      >
        {message}
      </FormErrorMessage>
    </FormControl>
  );
}
